// extracted by mini-css-extract-plugin
module.exports = {"action_menu":"C-Action-Panel_action_menu_3EBU7","action_group":"C-Action-Panel_action_group_1y5J8"};